// src/app/modules/admin/components/configuration-details/configuration-details.component.ts

import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PerfectScrollbarComponent, PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { ConfigurationVersion } from 'src/app/core/services/data/request/configuration.service';
import { ConfigurationSummary } from 'src/app/models/configuration-summary.model';

@Component({
  selector: 'app-configuration-detail',
  templateUrl: './configuration-details.component.html',
  styleUrls: ['./configuration-details.component.scss']
})
export class ConfigurationDetailComponent implements OnInit {
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  @Input() configurationSummary: ConfigurationSummary;
  @Input() configurationVersions: ConfigurationVersion[];
  @Output() closeConfigurationDetails = new EventEmitter();
  @Output() versionSelected = new EventEmitter<ConfigurationVersion>();

  selectedVersion: ConfigurationVersion;
  public config: PerfectScrollbarConfigInterface = {};
  versionDisplayColumns = ['version', 'modifiedDate', 'publishedBy', 'status'];

  constructor() { }

  ngOnInit() {
    if (this.configurationVersions && this.configurationVersions.length > 0) {
      this.selectedVersion = this.configurationVersions[0];
    }
  }

  selectVersion(version: ConfigurationVersion) {
    this.selectedVersion = version;
    this.versionSelected.emit(version);
  }

  close() {
    this.closeConfigurationDetails.emit();
  }
  
  getStatusLabel(status: string): string {   
    if (!status) return 'Unknown';    
    const upperStatus = status.toUpperCase();
    switch (upperStatus) {
      case 'ADDED':
        return 'Active';
      case 'REMOVED':
        return 'Deleted';
      default:
        return status;
    }
  }

}